import { tw } from "@careinfo/tailwind";
import React from "react";
import Button from "../../Reusable/Button";

const HoldOrder = (props: any) => {
  const { handleActionMenu, isLoading, setOrderActionMenu } = props;
  return (
    <>
      <section className={tw`bg-white text-center  mt-10`}>
        <p className={tw`text-lg font-semibold`}>
          Are you sure you want to continue?
        </p>
        <div className={tw`flex gap-x-4 items-center justify-center mt-6 `}>
          <button
            type="button"
            onClick={() => setOrderActionMenu(false)}
            className={tw`w-24 rounded py-2 bg-gray-500 text-white focus:outline-none`}
          >
            Cancel
          </button>
          <div className={tw`w-24`}>
            <Button
              type="button"
              label={"Yes"}
              isLoading={isLoading}
              onClick={() => handleActionMenu({}, {}, "Hold/Release")}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default HoldOrder;
